import { Box, CardContent, Typography } from '@material-ui/core';
import { Enrollment } from '@spike/membership-model';
import clsx from 'clsx';
import BookingActivityLog from 'components/Bookings2/BookingActivityLog';
import OrderDetail from 'components/OrderDetail';
import { ActivityLog } from 'components/UI/V3/ActivityLog';
import React from 'react';
import { formatActivityLog } from 'utils/ActivityLogFormatter';

const BOOKING_DETAIL_Z_INDEX = 10100;

interface ActivityLogSectionProps {
    enrollment: Enrollment;
    classes: { [key: string]: string };
}

interface BookingToView {
    bookingId: number;
    orderId?: number;
}

const ActivityLogSection: React.FC<ActivityLogSectionProps> = ({ enrollment, classes }) => {
    const [bookingToView, setBookingToView] = React.useState<BookingToView | null>(null);

    const [bookingPanelView, setBookingPanelView] = React.useState<'booking_detail' | 'activity_log'>('booking_detail');

    const openBookingHandler = React.useCallback((bookingId: number, orderId?: number) => {
        setBookingPanelView('booking_detail');
        setBookingToView({ bookingId, orderId });
    }, []);

    const closeBookingHandler = React.useCallback(() => {
        setBookingToView(null);
        setBookingPanelView('booking_detail');
    }, []);

    const activityLogEntries = React.useMemo(() => {
        if (!enrollment.activityLog || enrollment.activityLog.length === 0) {
            return [];
        }
        return formatActivityLog(enrollment.activityLog, { onOpenBooking: openBookingHandler });
    }, [enrollment.activityLog, openBookingHandler]);

    if (activityLogEntries.length === 0) {
        return null;
    }

    return (
        <>
            <Box
                className={classes.cardStyle}
                style={{ marginTop: 28 }}
            >
                <CardContent className={clsx(classes.cardContent, classes.cardWide)}>
                    <Typography
                        variant="h6"
                        className={classes.cardTitle}
                    >
                        Activity Log
                    </Typography>
                    <ActivityLog
                        entries={activityLogEntries}
                        title=""
                    />
                </CardContent>
            </Box>

            {bookingToView && bookingPanelView === 'booking_detail' && (
                <OrderDetail
                    bookingId={bookingToView.bookingId}
                    orderId={bookingToView.orderId}
                    zIndex={BOOKING_DETAIL_Z_INDEX}
                    onClose={closeBookingHandler}
                    onShowActivityLog={() => setBookingPanelView('activity_log')}
                />
            )}

            {bookingToView && bookingPanelView === 'activity_log' && (
                <BookingActivityLog
                    bookingId={bookingToView.bookingId}
                    zIndex={BOOKING_DETAIL_Z_INDEX}
                    onClose={() => setBookingPanelView('booking_detail')}
                    onPanelClose={closeBookingHandler}
                />
            )}
        </>
    );
};

export default ActivityLogSection;
